import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/core/helper/base.component';
import { OutletSelectionComponent } from '../outlet-selection/outlet-selection.component';

@Component({
  selector: 'app-outlet-popup',
  templateUrl: './outlet-popup.component.html',
  styleUrls: ['./outlet-popup.component.scss']
})
export class OutletPopupComponent  extends BaseComponent {

  constructor(
    private dialogRef: MatDialogRef<OutletSelectionComponent>,
  ) {
    super();
  }

  onOutletSelect() {
    this.dialogRef.close();
  }
}
